import React, { useEffect, useState } from "react";
import { AppBar, Avatar, Box, Toolbar, Typography } from "@mui/material";
import { Outlet } from "react-router-dom";
import { ReactComponent as LobyTextLogo } from "../../Icons/LobyTextLogo.svg";
import MenuBar from "./MenuBar";
import stringAvatar from "../../CommonComponents/Avatar";
import { StyledSecondaryServiceTypography } from "../../Theme";

const Header = () => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleWindowResize = () => {
      setInnerHeight(window.innerHeight);
    };
    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  });
  return (
    <>
      <Box
        sx={{
          height: "100%",
          width: "100%",
          display: "-ms-flexbox",
          boxSizing: "border-box",
        }}
      >
        <AppBar
          sx={{
            boxShadow: "none",
            borderBottom: "1px solid #D2D6DB",
            zIndex: 4,
            position: "fixed",
            backgroundColor: "#FFFFFF !important",
            borderRadius: "1px !important",
          }}
        >
          <Toolbar
            sx={{
              backgroundColor: "#FFFFFF !important",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <LobyTextLogo />
                <Box
                  sx={{ borderLeft: "2px solid #DDDDDD", marginLeft: "15px" }}
                >
                  <Box sx={{ marginLeft: "15px" }}>
                    <StyledSecondaryServiceTypography>
                      Operations Platform
                    </StyledSecondaryServiceTypography>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "187px",
                justifyContent: "center",
              }}
            >
              <Box
                ml={2}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  padding: "4px 10px",
                  borderRadius: "8px",
                  "&:hover": { backgroundColor: "#F3F4F6" },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    position: "relative",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Avatar
                    style={{ width: "32px", height: "32px", fontSize: "16px" }}
                    {...stringAvatar("Robert")}
                  />
                </Box>
                <Typography
                  sx={{
                    color: "#111927",
                    fontSize: "14px",
                    ml: 1,
                    fontWeight: 500,
                    maxWidth: "100px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  Robert Downy Junior
                </Typography>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>

        <Box
          sx={{
            display: "flex",
            backgroundColor: "#F0F0F0",
            pt: "65px",
            height: "calc(100% - 65px)",
            backgroundColor: "#F3F4F6",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "310px",
              display: { sm: "inherit", xs: "none" },
              borderRight: "2px solid #E5E7EB",
              minHeight: `${innerHeight - 66}px`,
            }}
          >
            <Box
              sx={{
                background: "#F3F4F6",
                height: "100%",
                overflowY: "auto",
                overflowX: "hidden",
                "&::-webkit-scrollbar": { width: "1.5px" },
                "&::-webkit-scrollbar-track": {
                  boxShadow: " inset 0 0 1.5px #D3D3D3",
                },
              }}
            >
              <MenuBar />
            </Box>
          </Box>
          <Box
            sx={{
              padding: "35px",
              overflow: "auto",
              width: "100%",
              background: "#F3F4F6",
              "::-webkit-scrollbar": { display: "none" },
            }}
          >
            <Outlet />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Header;
